<div #edit_container data-testid="edit_container" class="container-popup" *ngIf="action">

  <div class="ui-g-12 info-div flex">
    <span class="bold-span">ID: {{id}}</span>
    <span class="bold-span">{{ actionType }}-{{ name }}</span>
    <span class="bold-span">{{ discountType }} - {{description}}</span>
  </div>


  <div class="ui-g-12 info-div flex">
    <span class="bold-span">{{ 'campaign.emission_period' | translate }}: {{startEmissionDate | date: dateFormat}}
      {{ 'campaign.to' | translate }} {{endEmissionDate | date: dateFormat}}</span>
    <span class="bold-span" *ngIf="!fruitionRolling">{{ 'campaign.fruition_period_from' | translate }}: {{startFruitionDate | date:
      dateFormat}} {{ 'campaign.to' | translate }} {{endFruitionDate | date: dateFormat}}</span>
      <span class="bold-span" *ngIf="fruitionRolling" >{{'campaign.fruition_dates_variable'|translate}}</span>

  </div>

  <div class="ui-g-12 info-div flex">
    <div class="flex-row">
      <span>{{ 'campaign.generation_method' | translate }}: </span>
      <span class="bold answer">{{generationMethod}}</span>
    </div>
    <div class="flex-row">
      <span>{{ 'campaign.target_customers' | translate }}: </span>
      <span class="bold answer">{{ targetLoyaltyClass }}</span>
    </div>
    <div class="flex-row">
      <span>{{ 'campaign.generated_coupons' | translate }}: </span>
      <span class="bold answer">{{ actualGeneratedCoupon }}</span>
    </div>
  </div>
  



  <div class="ui-g-12 info-div flex">
    <div class="flex-row">
      <span>{{ 'campaign.threshold_emission' | translate }}:</span>
      <ng-container *ngIf="sogliaDiEmissione.value !== undefined && sogliaDiEmissione.value !== null">
        <span class="bold answer">{{ sogliaDiEmissione.type }} ({{ sogliaDiEmissione.value }})</span>
      </ng-container>
      <ng-container *ngIf="sogliaDiEmissione.value === undefined || sogliaDiEmissione.value === null">
        <span class="bold answer">{{ sogliaDiEmissione.type }}</span>
      </ng-container>
    </div>
    <div class="flex-row">
      <span>{{ 'campaign.repeatable_emission' | translate }}: </span>
      <ng-container
        *ngIf="emissioneRipetibile.value !== undefined && emissioneRipetibile.max !== undefined && (emissioneRipetibile.value !== 0 || emissioneRipetibile.max !== 0)">
        <span class="bold answer">{{ emissioneRipetibile.type }}
          <ng-container *ngIf="emissioneRipetibile.value !== 0 || emissioneRipetibile.max !== 0">
            ({{ emissioneRipetibile.value }}, {{ emissioneRipetibile.max }})
          </ng-container>
        </span>
      </ng-container>
      <ng-container
        *ngIf="emissioneRipetibile.value === undefined || emissioneRipetibile.max === undefined || (emissioneRipetibile.value === 0 && emissioneRipetibile.max === 0)">
        <span class="bold answer">{{ emissioneRipetibile.type }}</span>
      </ng-container>
    </div>


    <div class="flex-row">
      <span>{{ 'campaign.accumulators_in_emission' | translate }}: </span>
      <span class="bold answer">{{ accumulatoriEmissione }}</span>
    </div>
    <div class="flex-row">
      <span>{{ 'campaign.coupon_barcode' | translate }}: </span>
      <span class="bold answer">{{ barcodeCoupon }}</span>
    </div>
    <div class="flex-row">
      <span>{{ 'campaign.activator_barcode' | translate }}: </span>
      <span class="bold answer">{{ barcodeAttivazione }}</span>
    </div>
  </div>

  <div class="ui-g-12 info-div flex">
    <!--   <div class="flex-row">
      <span>Soglia di fruizione: </span>
      <span class="bold answer">{{ action.data.id ? action.data.id : 'null' }}</span>
    </div> -->


    <div class="flex-row">
      <span>{{ 'campaign.threshold_fruition' | translate }}:</span>

      <ng-container *ngIf="sogliaDiFruizione.value !== undefined && sogliaDiFruizione.value !== null">
        <span class="bold answer">{{ sogliaDiFruizione.type }} ({{ sogliaDiFruizione.value }})</span>
      </ng-container>
      <ng-container *ngIf="sogliaDiFruizione.value === undefined || sogliaDiFruizione.value === null">
        <span class="bold answer">{{ sogliaDiFruizione.type }}</span>
      </ng-container>
    </div>

    <div class="flex-row">
      <span>{{ 'campaign.coupon_value_points' | translate }}:</span>
      <!-- TODO chiedi a quale corrisponde -->
      <span class="bold answer">valore temporaneo</span>
    </div>

    <div class="flex-row">
      <span>{{ 'campaign.coupon_usage_number' | translate }}:</span>
      <span class="bold answer">{{ couponUseNumber }}</span>
    </div>
    
    <div class="flex-row">
      <span>{{ 'campaign.accumulators_in_fruition' | translate }}:</span>
      <span class="bold answer">{{ accumulatoriFruizione }}</span>
    </div>
    
  </div>


  <div class="ui-g-12 info-div flex">
    <div class="flex-row">
      <span>{{ 'campaign.distribution_list_issue' | translate }}:</span>
      <span class="bold answer">{{ listaDistribuzioneEmissione }}</span>
    </div>
    <div class="flex-row">
      <span>{{ 'campaign.distribution_list_fruition' | translate }}:</span>
      <span class="bold answer">{{ listaDistribuzioneFruizione }}</span>
    </div>
  </div>
  
  <div class="ui-g-12 info-div flex">
    <div class="flex-row">
      <span>{{ 'campaign.target_items_issue' | translate }}:</span>
      <span class="bold answer">{{ targetArticoliEmissione }}</span>
    </div>
    <div class="flex-row">
      <span>{{ 'campaign.target_items_fruition' | translate }}:</span>
      <span class="bold answer">{{ targetArticoliFruizione }}</span>
    </div>
  </div>
  
 <div class="ui-g-12 info-div flex">
  <div class="flex-row">
    <span>{{ 'campaign.touchpoint_emission' | translate }}:</span>
    <span class="bold answer">{{ touchPointEmissione }} - {{ numeroNegoziEmissione }}</span>
  </div>
  <div class="flex-row">
    <span>{{ 'campaign.touchpoint_fruition' | translate }}:</span>
    <span class="bold answer">{{ touchPointFruizione }} - {{ numeroNegoziFruizione }} (Numero negozi)</span>
  </div>
</div>

<div class="ui-g-12 info-div flex">
  <div class="flex-row">
    <span>{{ 'campaign.wizard_emission' | translate }}:</span>
    <span class="bold answer">{{ wizardEmissione }}</span>
  </div>
  <div class="flex-row">
    <span>{{ 'campaign.wizard_fruition' | translate }}:</span>
    <span class="bold answer">{{ wizardFruizione }}</span>
  </div>
</div>

<div class="ui-g-12 info-div flex" *ngIf="summaryAccumulatorToMove.length > 0 || summaryAccumulatorToControl.length > 0">
     <span class="section-title">{{ 'campaign.emission' | translate }}</span>
  <div class="flex-row" *ngFor="let item of summaryAccumulatorToMove">
    <span>{{ 'campaign.acmdamuovere' | translate }}:</span>
    <span class="bold answer">{{ item.acmDescription }} ({{ item.acm_code }})</span>
  </div>

  <div class="flex-row" *ngFor="let item of summaryAccumulatorToControl">
    <span>{{ 'campaign.acmDacontrollare' | translate }}:</span>
    <span class="bold answer">{{ item.acmDescription }} ({{ item.acm_code }})</span>
  </div>

</div>

<div class="ui-g-12 info-div flex" *ngIf="summaryAccumulatorToMoveFruition.length > 0 || summaryAccumulatorToControlFruition.length > 0">
  <span class="section-title">{{ 'campaign.fruition' | translate }}</span>

  <div class="flex-row" *ngFor="let item of summaryAccumulatorToMoveFruition">
 <span>{{ 'campaign.acmdamuovere' | translate }}:</span>
     <span class="bold answer">{{ item.acmDescription }} ({{ item.acm_code }})</span>
  </div>

  <div class="flex-row" *ngFor="let item of summaryAccumulatorToControlFruition">
    <span>{{ 'campaign.acmDacontrollare' | translate }}:</span>
    <span class="bold answer">{{ item.acmDescription }} ({{ item.acm_code }})</span>
  </div>

</div>



</div>



// WEBPACK FOOTER //
// ./src/app/views/campaign-3/info-action-3/info-action-3.component.html